import React from 'react'
import CardActions from '@material-ui/core/CardActions'
import EditButton from '../components/EditButton'

export default ({ basePath, data }) => (
  <CardActions>
    <EditButton basePath={basePath} record={data} />
  </CardActions>
)
